import { render } from "./TabWithTable.vue?vue&type=template&id=dd138340&scoped=true"
import script from "./TabWithTable.vue?vue&type=script&lang=js"
export * from "./TabWithTable.vue?vue&type=script&lang=js"

import "./TabWithTable.vue?vue&type=style&index=0&id=dd138340&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/store/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd138340"]])

export default __exports__